module.exports = __webpack_public_path__ + "static/img/index-banner.b4a4ecc6.png";